import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  id: "app",
  class: "app-inner"
};
const _hoisted_2 = {
  id: "navigator",
  class: "navigator"
};
const _hoisted_3 = {
  id: "app-body",
  class: "app-body"
};
const _hoisted_4 = {
  key: 0,
  id: "app-foot"
};
const _hoisted_5 = {
  id: "bottom-button",
  class: "bottom-button"
};
import { onMounted } from "vue";
import { Crisp } from "crisp-sdk-web";
import { useRouter } from "vue-router";
import navigator from "./components/common/common_nav.vue";
import foot from "./components/common/common_foot.vue";

// 引入icon
import iconArrowUp from "./components/common/icon_arrow_up.vue";
import iconHome from "./components/common/icon_home.vue";
import iconBalloon from "./components/common/icon_balloon.vue";

// 判断当前url，用于显示是显示iconHome还是iconBalloon
import { ref } from "vue";
export default {
  __name: 'App',
  setup(__props) {
    onMounted(() => {
      Crisp.configure("9bc85d1c-ef91-4a7f-a997-050eb1abcdee");
    });
    const scrollToTop = () => {
      const appBody = document.getElementById("app-body");
      // 模拟滚动到顶部
      if (appBody) {
        appBody.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    };
    const router = useRouter();
    const backToHome = () => {
      if (isShowHome.value) {
        router.push("/");
      } else {
        window.$crisp.push(["do", "chat:open"]);
      }
    };
    const isShowHome = ref(true);
    // 每次改变url时，判断url是否是purchase及其子页面，如果是则不显示iconHome
    router.afterEach(to => {
      if (to.path.includes("encouragement") || to.path.includes("encouragement") || to.path.includes("cart")) {
        isShowHome.value = false;
      } else {
        isShowHome.value = true;
      }
    });

    // 让bottom-button在app-body距离顶部100px时显示，越往下透明度越高
    onMounted(() => {
      const appBody = document.getElementById("app-body");
      if (appBody) {
        appBody.addEventListener("scroll", () => {
          const bottomButton = document.getElementById("bottom-button");
          if (bottomButton) {
            // 获取滚动的距离
            const scrollTop = appBody.scrollTop;
            // 获取整个页面的高度 + 滚动的高度
            const scrollHeight = appBody.scrollHeight - appBody.clientHeight;
            const opacity = Math.max(scrollTop / scrollHeight, 0.2);
            bottomButton.style.opacity = opacity;
          }
        });
      }
    });

    // 判断footer是否需要显示。如果页面的url来自于purchase及其子页面，则不显示footer
    const isShowFooter = ref(true);
    const currentPath = router.currentRoute.value.path;
    // 如果url中有purchase，则不显示footer
    if (currentPath.includes("purchase")) {
      isShowFooter.value = false;
    }
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(navigator)]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_router_view), isShowFooter.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(foot)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        id: "back-to-home",
        class: "imgbtn",
        onClick: backToHome
      }, [isShowHome.value ? (_openBlock(), _createBlock(iconHome, {
        key: 0
      })) : (_openBlock(), _createBlock(iconBalloon, {
        key: 1
      }))]), _createElementVNode("div", {
        id: "back-to-top",
        class: "imgbtn",
        onClick: scrollToTop
      }, [_createVNode(iconArrowUp)]), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "icp"
      }, [_createElementVNode("a", {
        href: "https://beian.miit.gov.cn/",
        target: "_blank"
      }, "粤ICP备2021087346号-1")], -1))])]);
    };
  }
};